export const blockIconsAndroidGraphicEqNew = (
	<span className='material-symbols-outlined'>graphic_eq</span>
);
